import { TranscriptorConsultation } from '../config';

import { isUploadNotCompleted } from './uploadNotCompleted';

export const canReorderConsultation = (
  consultation: Partial<
    Pick<TranscriptorConsultation, 'status' | 'error' | 'recordingMode'>
  >,
): boolean =>
  consultation.recordingMode !== 'dictation' &&
  (consultation.status === 'succeeded' || consultation.status === 'failed') &&
  !isUploadNotCompleted(consultation);
